var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"toolbar-container"}}),_c('div',{staticClass:"ck ck-toolbar ck-toolbar_grouping ck-reset_all ck-rounded-corners"},[_c('file-manager',{on:{"selected":_vm.uploadImage}})],1),_c('div',{attrs:{"id":"editor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }